<template lang="html">
    <Modal
      v-if="browserWarningIsVisible"
      :type="'notification'"
      :title="'Keyboard onboarding'"
      :alignment="'top'"
      :withCloseButton="true"
      :applyWarningColors="applyWarningColors"
      :listenToGestures="false"
      @close="dismissBrowserWarning"
    >
      <h2 class="h3">A quick warning</h2>
      <p>{{apology}}</p>
    </Modal>
    <Modal
      v-else-if="keyboardNotificationIsVisible"
      :type="'notification'"
      :title="'Keyboard onboarding'"
      :alignment="'top'"
      :withCloseButton="true"
      :autoCloseInterval="30"
      :hovering.sync="hovering"
      :applyWarningColors="applyWarningColors"
      @autoClose="onAutoClose"
      @close="completeOnboarding"
    >
      <h2 class="h3">You can control Big Timer with the keyboard:</h2>
      <p class="small-displays">If your device has a keyboard, you can use it for the following:</p>
      <p class="large-displays"> </p>
      <NotificationContentKeyboard />
    </Modal>
</template>

<script>
import Modal from './Modal'
import NotificationContentKeyboard from './NotificationContentKeyboard'

export default {

  name: 'TheOnboarding',

  components: {
    Modal,
    NotificationContentKeyboard
  },

  props: {
    onboardingComplete : {
      required: true,
      type: Boolean
    },
    timerIsRunning : {
      required: true,
      type: Boolean
    },
    controlsAreVisible : {
      required: true,
      type: Boolean
    },
    hoveringOnNotification: {
      required: true,
      type: Boolean
    },
    visibleTray: {
      required: true,
      type: String
    },
    browser: {
      required: false,
      type: String
    },
    applyWarningColors: {
      required: false,
      type: Boolean
    },
  },

  data() {
    return{

      // Configuration
      ////////////////

      // Time in ms until onboarding starts
      startDelay: 10000,

      // Other
      ////////
      onboardingIsActive: false,  // Defines, combined with controlsAreVisible, if notif is visible.
      hovering: false,             // Mouse hover on notification prevents auto closing
      browserWarningIsVisible: false,
      apology: '',
    }
  },

  mounted() {
    this.startOnboarding()
  },

  destroyed(){
    this.$emit('update:hoveringOnNotification', false)
  },

  methods: {

    startOnboarding () {
      // For IE users only

      if (this.browser === "IE"){
        this.apology = 'It looks like you’re using Internet Explorer, a very old web browser. Please use Firefox, Chrome, Safari or Edge instead. Future versions of Big Timer won’t work in Internet Explorer.'
        this.browserWarningIsVisible = true
      }
      // The onboarding starts with a delay.
      setTimeout(() => {

        // Try again later if busy
        if (!this.controlsAreVisible || this.timerIsRunning || this.visibleTray || this.browserWarningIsVisible){
          this.startOnboarding()
        }
        else {
          this.onboardingIsActive = true
        }
      }, this.startDelay)
    },

    onAutoClose(){
      this.onboardingIsActive = false
      this.$emit('close')
    },

  	completeOnboarding () {
  		this.onboardingIsActive = false
      this.$emit('update:onboardingComplete', true)
      this.$emit('close')
  	},

    dismissBrowserWarning(){
      this.browserWarningIsVisible = false
    }
  },

  computed: {
    keyboardNotificationIsVisible(){
      return this.onboardingIsActive && this.controlsAreVisible
    }
  },

  watch: {
    hovering(newVal){
      this.$emit('update:hoveringOnNotification', newVal)
    }
  },
}
</script>

<style lang="scss">
// Responsive content

.large-displays{
  display: none;
}

@media screen and (min-width: 800px) {

  .small-displays{
    display: none;
  }
  .large-displays{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheOnboarding.vue